import { ICONS_ALIASES } from '_constants/icons';
import ArrowRightSvg from './assets/ArrowRightSvg';
import ArrowTwoToneLeftSvg from './assets/ArrowTwoToneLeftSvg';
import StarCheckSvg from './assets/StarCheckSvg';
import SadCircleSvg from './assets/SadCircleSvg';

const icons = {
  [ICONS_ALIASES.arrowRight]: ArrowRightSvg,
  [ICONS_ALIASES.arrowTwoToneLeft]: ArrowTwoToneLeftSvg,
  [ICONS_ALIASES.sadCircle]: SadCircleSvg,
  [ICONS_ALIASES.starCheck]: StarCheckSvg,
};

const Icon = ({ alias, color, width, height }) => {
  const Icon = icons[alias];

  if (!Icon) {
    return null;
  }

  return <Icon color={color} width={width} height={height} />;
};

export default Icon;
